import React from "react";

import { useTranslation } from "react-i18next";

import prettyDurations from "../../../utils/durations";

import type { JSX } from "react";

interface AdsObjectiveTooltipProps {
  title: string;
  duration: number;
  number: number;
}

function AdsObjectiveTooltip({
  title,
  duration,
  number,
}: AdsObjectiveTooltipProps): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  const durationFormated = prettyDurations(duration, {
    valueUnit: "s",
  }).humanised;

  return (
    <div className="flex flex-col gap-[0.3125rem] text-left">
      <span className="text-center">{title}</span>
      <div className="flex gap-[0.78125rem]">
        <div className="flex flex-col gap-[0.3125rem] text-nowrap">
          <span>{t("duration")}</span>
          <span>{t("number")}</span>
        </div>
        <div className="flex flex-col gap-[0.3125rem] text-nowrap">
          <span className="font-semibold">{durationFormated}</span>
          <span className="font-semibold">{number}</span>
        </div>
      </div>
    </div>
  );
}

export default AdsObjectiveTooltip;
